// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('stock.scannerinventorying', {
        url: '/scanner?prev&filter&page&pageSize',
        views: {
            "wideColumnView@stock": {
                templateUrl: 'main/stock/scannerinventorying/scannerinventorying.tpl.html',
                controller: 'ScannerInventoryingController as vm'
            }
        },
        resolve: {
            searchTerms: searchTermsResolver,
            inventories: InventoriesResolver
        }
    });
}

// @ngInject
function searchTermsResolver($stateParams) {
    return {
        filter: $stateParams.filter ? $stateParams.filter : '',
        currentPage: $stateParams.page ? $stateParams.page : 1,
        pageSize : $stateParams.pageSize ? $stateParams.pageSize : 20,
        prev : $stateParams.prev
    };
}

// @ngInject
function InventoriesResolver($stateParams, InventoryingApiService) {
    return InventoryingApiService.getAll($stateParams.page, $stateParams.filter, $stateParams.pageSize);
}

// @ngInject
function ScannerInventoryingController($state, searchTerms, inventories, loadSpinnerService, InventoryingApiService, NewInventoryDialogService, $rootScope) {
    var vm = this;
    var ordersGrid = {};

    vm.currentPage = searchTerms.currentPage;
    vm.itemsPerPage = searchTerms.pageSize;
    vm.totalItems = inventories.totalItems;
    vm.searchTerm = searchTerms.filter;
    vm.previouslySelectedInventoryId = searchTerms.prev;

    vm.inventories = inventories.data;
    formatPlannedDeliveryDate(vm.inventories);

    vm.statusIcons = {
        created: 'fa-upload',
        fileImported: 'fa-file-text-o',
        pending: 'fa-clock-o',
        completed: 'fa-check',
        deleted: 'fa-trash-o'
    };
    
    vm.typeIcons = {
        modelInventory: 'fa-tag',
        inventoryWhole: 'fa-archive',
        inventoryPart: 'fa-tags'
    };

    vm.searchTermChange = searchTermChange;
    vm.loadOrders = loadOrders;
    vm.openNewInventoryModal = openNewInventoryModal;
    vm.selectInventory = selectInventory;
    
    activate();

    function activate() {
        $rootScope.$on('NavigatingTo', function(event, response) {
            if (response === 'stock.scannerinventorying') {
                searchTermChange();
            }
        });
    }

    function loadOrders(inventoryItem) {
        loadSpinnerService.start('mainSpinner');
        InventoryingApiService.getAll(vm.currentPage, vm.searchTerm, vm.itemsPerPage).then(function getAllOrders(response) {
            vm.inventories = response.data;
            vm.totalItems = response.totalItems;
            formatPlannedDeliveryDate(vm.inventories);

            if (inventoryItem && inventoryItem.id) {
                hideInventoriesGrid(_.find(vm.inventories, function(o) { return o.id === inventoryItem.id; }));
                $state.go('stock.scannerinventorying.inventory', { inventoryId: inventoryItem.id });
            }
        }).finally(function afterGetAllOrders() {
            loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }

    function formatPlannedDeliveryDate(inventories) {
        for (var i = 0; i < inventories.length; i++) {
            var inventory = inventories[i];
            inventory.inventoryDate = inventory.inventoryDate.replace('T', ' ').substring(0, 19);
        }
    }

    function openNewInventoryModal() {
        NewInventoryDialogService.showDialog().then(function(result) {
            if (result && result.success) {
                selectInventory(result.inventoryItem);
            }
        });
    }

    function selectInventory(inventory){
        if (inventory && inventory.id) {
            $state.go('stock.scannerinventorying.inventory', {prev: undefined, inventoryId: inventory.id});
        }
        else{
            searchTermChange(true);
        }
    }

    function searchTermChange(forceRefresh = false) {

        $state.go('stock.scannerinventorying', 
        {
            page: vm.currentPage,
            pageSize: vm.itemsPerPage,
            filter: vm.searchTerm,
        },
            {notify: forceRefresh}
        );

        vm.isHidingInventoriesGrid = false;
        loadOrders();
    }
}

angular.module('stock.scannerinventorying', ['scannerinventorying.inventory'])
    .config(stateConfig)
    .controller('ScannerInventoryingController', ScannerInventoryingController);
